(function ($) {
  /**
   * Object for management products on Cart page
   */
  window.MealCart = {
    handles: ['breakfast', 'entree', 'breakfast-m2-low-fodmap', 'entree-m2-low-fodmap'],
    addits: [],
    additionals: [],
    items: {},
    minPurchase: localStorage.getItem('minPurchase'),
    /**
     * Update and show total price and items count
     */
    showCounters: function () {
      // change total counters
      var keys = Object.keys(this.items),
        total = 0,
        count = 0;

      for (var i in keys) {
        var item = this.items[keys[i]];

        total += item.price * item.qty;
        count += item.qty;
      }
      // remove notes from cart
      if (count === 0) {
        CartUtil.updateAttrs({}, function () {
          CartUtil.updateNote('', function () {
            CartUtil.clear(function () {
              window.location.reload();
            });
          });
        });
      }
      // display counters
      $('.cart-subtotal__price').text('$' + Number(total).toFixed(2));
      $('.cart__items-count').text(count);
    },
    /**
     * Update Edit links in the Cart page
     */
    linkToEdit: function () {
      var $links = $('.cart-edit-constructor-link'),
        localStorageConstructorData = JSON.parse(localStorage.getItem('modifyConstructorStorage'));

      if (!$links.length || localStorageConstructorData === null) return false;

      var configPageUrl = typeof localStorageConstructorData.configPageUrl !== 'undefined' ? localStorageConstructorData.configPageUrl : '';
      if (configPageUrl.length) {
        $links.attr('href', configPageUrl);
      }
    },
    /**
     * Validate additional meals items count
     */
    checkTotal: function () {
      var $this = this,
        total = 0;

      //Get totals excluding Dietitian and counting Low-FODMAP Program as 14 or 21 meals
      function disableSubmit() {
        // const minPurchase = localStorage.getItem('minPurchase');
        $('.cart__submit-controls input').prop('disabled', true);
        $('.addits_count_left').text(this.minPurchase - total);
        $('.addits_proceed_to_cart_msg').show();
      }

      function enableSubmit() {
        $('.cart__submit-controls input').prop('disabled', false);
        $('.addits_proceed_to_cart_msg').hide();
      }

      $('.cart__qty-input').each(function () {
        var id = $(this).attr('id'),
          key = id.replace('updates_large_', ''),
          quantity = parseInt($(this).val()),
          itemTitle = $('.cart__qty-input[id$="' + key + '"]')
            .closest('.cart-product__item')
            .find('.cart__product-title')
            .text()
            .trim()
            .toLowerCase(),
          $metaTexts = $('.cart__qty-input[id$="' + key + '"]')
            .closest('.cart-product__item')
            .find('.cart__meta-text'),
          programQuantityItems = 0;

        if (!itemTitle.includes('dietitian')) {
          if (itemTitle.includes('program')) {
            $metaTexts.each(function (index, item) {
              var metaTitle = $(item).text().trim().toLowerCase();

              if (metaTitle.includes('includes breakfast')) {
                programQuantityItems = 21;
                return false;
              }
            });

            total += programQuantityItems === 21 ? 21 * quantity : 14 * quantity;
          } else {
            total += quantity;
          }
        }
      });
      // const minPurchase = localStorage.getItem('minPurchase');
      if (total >= this.minPurchase || total === 0) {
        enableSubmit();
        for (var i in $this.addits) {
          var key = $this.addits[i];

          $('.cart__qty-input[id$="' + key + '"]').css('border-color', 'rgba(151,151,151,0.5)');
        }
        return true;
      }
      for (var _i in $this.addits) {
        var _key = $this.addits[_i];

        $('.cart__qty-input[id$="' + _key + '"]').css('border-color', '#ff0000');
      }
      disableSubmit();

      return false;
    },
    /**
     * Track updating products quantity
     */
    updateQty: function (qtyEl, key, qty) {
      // update cart logic
      var itemTotal = qtyEl.closest('.cart-product__item').find('.item_total_price');

      this.items[key].qty = qty;
      itemTotal.text('$' + Number(this.items[key].price * qty).toFixed(2));

      CartUtil.ajaxpost('/cart/change.js', {
        quantity: this.items[key].qty,
        id: key,
      });

      this.showCounters();
    },
    clearLocalStorage: function () {
      $('form.cart').on('submit', function () {
        localStorage.removeItem('modifyConstructorStorage');
      });
    },
    /**
     * Initialize Cart page controls and events
     */
    init: function () {
      var $this = this;

      $this.checkTotal();
      $this.linkToEdit();
      $this.clearLocalStorage();

      CartUtil.ajaxget('/cart.js', function (cart) {
        var items = cart.items;

        if (!cart.item_count.length) {
          CartUtil.updateAttrs({}, function () {
            CartUtil.updateNote('', function () {});
          });
        }

        if (items.length > 0) {
          for (var i in items) {
            var item = items[i];

            if ($this.handles.indexOf(item.handle) > -1) {
              $this.addits.push(item.key);
            }
          }
          // increment quantity
          $('.cart__qty .inc').on('click', function () {
            var el = $(this).closest('.cart__qty').find('.cart__qty-input'),
              val = parseInt(el.val());
            val++;
            el.val(val);
            el.trigger('change');
          });
          // decrement quantity
          $('.cart__qty .dec').on('click', function () {
            var el = $(this).closest('.cart__qty').find('.cart__qty-input'),
              val = parseInt(el.val());
            val--;
            el.val(val);
            el.trigger('change');
          });
          // bind change events on quantity inputs
          $('.cart__qty-input').each(function () {
            var id = $(this).attr('id'),
              key = id.replace('updates_large_', ''),
              varId = $(this).attr('data-id'),
              qty = parseInt($(this).val());

            if (!qty) {
              qty = 0;
            }

            if (!key.match(/^\d+:.+/)) {
              return;
            }
            // init cart items via template data
            $this.items[key] = {
              qty: qty,
              price: parseFloat($(this).attr('data-price')),
              id: varId,
            };
            // remove button
            var removeEl = $(this).closest('.grid').find('.cart__remove > a');
            removeEl.on('click', function (e) {
              var qtyEl = $(this).closest('.grid').find('.cart__qty-input');

              e.preventDefault();
              qtyEl.val(0);
              qtyEl.trigger('change');

              $this.checkTotal();

              return false;
            });
            // change quantity
            $(this).on('change', function () {
              var id = $(this).attr('id'),
                key = id.replace('updates_large_', ''),
                qty = parseInt($(this).val());

              if (!qty) {
                qty = 0;
              }

              if (qty === 0) {
                // if remove Meal Plan then remove consultation too
                if ($(this).attr('data-sku') === 'mod_fnl_000001' || $(this).attr('data-sku') === 'mod_fnl_000002') {
                  var dietEl = $('.cart__qty-input[data-sku="mod_dco_000001"]');

                  if (dietEl.length > 0) {
                    dietEl.val(0);
                    dietEl.trigger('change');
                  }
                } else if ($(this).attr('data-sku') === 'mod_dco_000001') {
                  // when removing the consultation then unset healthieScheduler attribute too
                  var attrs = cart.attributes;
                  delete attrs['healthieScheduler'];
                  CartUtil.updateAttrs(attrs);
                }

                $(this).closest('.cart-product__item').remove();
              }
              // additional meals logic
              $this.checkTotal();
              $this.updateQty($(this), key, qty);
            });

            $this.updateQty($(this), key, qty);
          });

          if ($this.addits.length > 0) {
            $this.checkTotal();
          }
          $this.showCounters();
        } else {
          CartUtil.updateAttrs({}, function () {
            CartUtil.updateNote('', function () {
              CartUtil.clear();
            });
          });
        }
      });
    },
  };
})(jQuery);
